import React from 'react';
import { Icon } from '../Icon';
import styles from './ReviewSlide.css';

const REVIEWS = [
    {
        title: 'As easy as talking to an old friend',
        quote: 'I’m not big on technology, but Boundly made it easy. I simply talked into my phone like I was chatting with an old friend. I want my kids to have our family stories.',
        name: 'Paul',
        date: 'September'
    },
    {
        title: 'Mom’s stories we never knew we were missing',
        quote: 'I got this for my mom and she remembered so many stories from her childhood, her first love, her whole life. We never knew half of it. The whole family is in awe. Best gift we’ve ever given her.',
        name: 'Natalie',
        date: 'September'
    },
    {
        title: 'A bridge to my kids, one story at a time',
        quote: 'My kids live abroad, and I don’t know when I’ll see them next. Perhaps through my stories, we’ll feel more connected.',
        name: 'Ruby',
        date: 'September'
    }
];

function ReviewSlide() {
    return (
        <div className={styles.form}>
            <h2 className={styles.heading}>
                What it feels like to finally tell your story <span className={styles.highlight}>in their own words</span>
            </h2>
            <ul className={styles.list}>
                {REVIEWS.map(review => (
                    <li key={review.name} className={styles.card}>
                        <p className={styles.title}>{review.title}</p>
                        <p className={styles.quote}>“{review.quote}”</p>
                        <div className={styles.footer}>
                            <p className={styles.author}><span className={styles.name}>{review.name},</span> {review.date}</p>
                            <span className={styles.badge}>
                                <Icon name='verifiedFill' className={styles.badgeIcon} />
                                Verified
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export {
    ReviewSlide
};
